/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGoCampaign_OfficeGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for OfficeGroups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, July 11, 2019 - 02:26:10 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      07/11/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    OFFICEGROUP_LIST_CONTAINER_LOADED,
    OFFICEGROUP_LIST_CONTAINER_UNLOADED,
    OFFICEGROUP_LIST_TABLE_LOADED,
    OFFICEGROUP_LIST_TABLE_UNLOADED,

    OFFICEGROUP_LIST_CHANGE_GROUP,
    OFFICEGROUP_SET_GROUP_SELECT,

    OFFICEGROUP_SELECT_ROW,
    OFFICEGROUP_ADD,
    OFFICEGROUP_EDIT,
    OFFICEGROUP_DELETE,
    OFFICEGROUP_OPEN_WARNING,
    OFFICEGROUP_CLOSE_WARNING,
    OFFICEGROUP_DELETE_DISABLE,

    OFFICEGROUP_EDIT_CONTAINER_LOADED,
    OFFICEGROUP_EDIT_CONTAINER_UNLOADED,
    OFFICEGROUP_EDIT_FORM_LOADED,
    OFFICEGROUP_EDIT_FORM_UNLOADED,
    OFFICEGROUP_EDIT_DATA_LOAD,
    OFFICEGROUP_EDIT_CONTAINER_SUBMIT,
    OFFICEGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeGoCampaign_OfficeGroups';

const defaultState = {
    refreshList: false,
    danger: false,
    officegroupid: 0,
    countryid: 0,
    stateid_f: 0,
    countyid_f: 0,
    cityid_f: 0,
    politicaldistrictgroupid_f: 0,
    name: '',
    description: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case OFFICEGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                officegroups: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
                counties: action.payload[3] ? action.payload[3].records : null,
                cities: action.payload[4] ? action.payload[4].records : null,
            }
        case OFFICEGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case OFFICEGROUP_LIST_CHANGE_GROUP:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case OFFICEGROUP_SELECT_ROW:
            return {
                ...state,
                officegroupid: action.id
            }
        case OFFICEGROUP_ADD:
            return {
                ...state
            }
        case OFFICEGROUP_EDIT:
            return {
                ...state,
                officegroupid: action.id
            }
        case OFFICEGROUP_DELETE:
            return {
                ...state,
                officegroupid: null
            }
        case OFFICEGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case OFFICEGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case OFFICEGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case OFFICEGROUP_EDIT_CONTAINER_LOADED:
        case OFFICEGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                officegroupid: action.payload[0] ? action.payload[0].officegroupid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                countyid: action.payload[0] ? action.payload[0].countyid : 0,
                county: action.payload[3] ? action.payload[3].name : action.payload[0] ? action.payload[0].county : '',
                cityid: action.payload[0] ? action.payload[0].cityid : 0,
                city: action.payload[4] ? action.payload[4].city : action.payload[0] ? action.payload[0].city : '',
                politicaldistrictgroupid: action.payload[0] ? action.payload[0].politicaldistrictgroupid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                orderid: action.payload[0] ? action.payload[0].orderid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case OFFICEGROUP_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case OFFICEGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case OFFICEGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case OFFICEGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case OFFICEGROUP_LIST_CONTAINER_UNLOADED:
        case OFFICEGROUP_LIST_TABLE_UNLOADED:
        case OFFICEGROUP_EDIT_CONTAINER_UNLOADED:
        case OFFICEGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGoCampaign_OfficeGroups.js